(function () {
  const modal = document.getElementById('SizeGuideModal');
  if (!modal) return;

  /* ---------------------------------------------------------------
     Sizing data (derived from the provided Numbers sheets)
     Matrix rows = height bucket, columns = weight bucket.
     Each cell:
     {
       shirt: "L",
       shirtLoose: "XL", // optional, exact ležernije/šire top value from table
       pants: "L31 W32",
       pantsLoose: "L33 W32" // optional, exact relaxed/ležernije value from table
     }
  --------------------------------------------------------------- */
  const HEIGHT_RANGES = [
    { min: 0,      max: 157 }, // do 157
    { min: 157.01, max: 160 }, // 157.01-160
    { min: 160.01, max: 170 }, // 160.01-170
    { min: 170.01, max: 177 }, // 170.01-177
    { min: 177.01, max: 183 }, // 177.01-183
    { min: 183.01, max: 190 }, // 183.01-190
    { min: 190.01, max: 197 }, // 190.01-197
    { min: 197.01, max: 205 }, // 197.01-205
    { min: 205.01, max: 210 }, // 205.01-210
    { min: 210.01, max: 215 }, // 210.01-215
    { min: 215.01, max: 999 }  // preko 215.01
  ];

  const WEIGHT_RANGES = [
    { min: 0,      max: 60 },  // do 60
    { min: 60.01,  max: 65 },  // 60.01-65
    { min: 65.01,  max: 73 },  // 65.01-73
    { min: 73.01,  max: 80 },  // 73.01-80
    { min: 80.01,  max: 87 },  // 80.01-87
    { min: 87.01,  max: 95 },  // 87.01-95
    { min: 95.01,  max: 105 }, // 95.01-105
    { min: 105.01, max: 112 }, // 105.01-112
    { min: 112.01, max: 120 }, // 112.01-120
    { min: 120.01, max: 999 }  // više od 120.01
  ];

  const _ = null; // no experience

  const MATRIX = [
    // <157
    [_, _, _, _, _, _, _, _, _, _],

    // 157-160
    [
      _,
      { shirt: 'S', pants: 'L29 W31' },
      { shirt: 'S', pants: 'L29 W31' },
      { shirt: 'S', pants: 'L29 W31', pantsLoose: 'L29 W32' },
      { shirt: 'S', pants: 'L29 W31', pantsLoose: 'L29 W32' },
      _, _, _, _, _
    ],

    // 160-170
    [
      _,
      { shirt: 'S', pants: 'L29 W31' },
      { shirt: 'S', pants: 'L29 W31' },
      { shirt: 'S', pants: 'L29 W31', pantsLoose: 'L29 W32' },
      { shirt: 'S', shirtLoose: 'M', pants: 'L29 W32', pantsLoose: 'L29 W33' },
      { shirt: 'M', pants: 'L29 W34' },
      { shirt: 'L', shirtLoose: 'XL', pants: 'L29 W36' },
      { shirt: 'XL', shirtLoose: '2XL', pants: 'L29 W38' },
      _, _
    ],

    // 170-177
    [
      _,
      { shirt: 'S', pants: 'L29 W31' },
      { shirt: 'S', shirtLoose: 'M', pants: 'L29 W32', pantsLoose: 'L29 W33' },
      { shirt: 'S', shirtLoose: 'M', pants: 'L29 W32', pantsLoose: 'L29 W33' },
      { shirt: 'M', pants: 'L29 W32', pantsLoose: 'L29 W33' },
      { shirt: 'L', pants: 'L29 W33', pantsLoose: 'L29 W34', pantsFit: 'knap' },
      { shirt: 'XL', pants: 'L29 W36' },
      { shirt: 'XL', shirtLoose: '2XL', pants: 'L29 W38' },
      _, _
    ],

    // 177-183
    [
      _,
      { shirt: 'S', pants: 'L29 W31' },
      { shirt: 'S', shirtLoose: 'M', pants: 'L29 W31', pantsLoose: 'L29 W32' },
      { shirt: 'S', shirtLoose: 'M', pants: 'L29 W32' },
      { shirt: 'M', pants: 'L29 W32', pantsLoose: 'L29 W33', pantsFit: 'knap' },
      { shirt: 'L', pants: 'L29 W33', pantsLoose: 'L29 W34', pantsFit: 'knap' },
      { shirt: 'XL', pants: 'L29 W36' },
      { shirt: '2XL', shirtLoose: '3XL', pants: 'L29 W36', pantsLoose: 'L29 W38', pantsFit: 'knap' },
      { shirt: '3XL', pants: 'L29 W38' },
      _
    ],

    // 183-190
    [
      _,
      _,
      { shirt: 'M', pants: 'L31 W31' },
      { shirt: 'M', pants: 'L31 W32' },
      { shirt: 'L', pants: 'L31 W32', pantsLoose: 'L31 W33', pantsFit: 'knap' },
      { shirt: 'L', pants: 'L31 W34' },
      { shirt: 'XL', pants: 'L31 W36' },
      { shirt: '2XL', pants: 'L31 W36', pantsLoose: 'L31 W38' },
      { shirt: '3XL', pants: 'L31 W38' },
      _
    ],

    // 190-197
    [
      _,
      _,
      { shirt: 'L', pants: 'L31 W31', pantsLoose: 'L33 W31' },
      { shirt: 'L', pants: 'L31 W32', pantsLoose: 'L33 W32' },
      { shirt: 'L', pants: 'L31 W32', pantsLoose: 'L33 W33' },
      { shirt: 'L', pants: 'L31 W34', pantsLoose: 'L33 W34' },
      { shirt: 'XL', pants: 'L31 W36', pantsLoose: 'L33 W36' },
      { shirt: '2XL', shirtLoose: '3XL', pants: 'L31 W36', pantsLoose: 'L33 W38' },
      { shirt: '3XL', pants: 'L31 W38' },
      _
    ],

    // 197-205
    [
      _,
      _,
      _,
      { shirt: 'L', pants: 'L33 W31', pantsLoose: 'L33 W32' },
      { shirt: 'L', pants: 'L33 W32', pantsLoose: 'L33 W33' },
      { shirt: 'L', pants: 'L33 W33', pantsLoose: 'L33 W34' },
      { shirt: 'XL', shirtLoose: '2XL', pants: 'L33 W36' },
      { shirt: '2XL', shirtLoose: '3XL', pants: 'L33 W36', pantsLoose: 'L33 W38' },
      { shirt: '3XL', pants: 'L33 W38' },
      _
    ],

    // 205-210
    [
      _,
      _,
      _,
      _,
      { shirt: 'XL', pants: 'L33 W31', pantsLoose: 'L33 W32' },
      { shirt: 'XL', pants: 'L33 W33', pantsLoose: 'L33 W34' },
      { shirt: '2XL', pants: 'L33 W36' },
      { shirt: '2XL', shirtLoose: '3XL', pants: 'L33 W36', pantsLoose: 'L33 W38' },
      { shirt: '3XL', pants: 'L33 W38' },
      _
    ],

    // 210-215
    [
      _,
      _,
      _,
      _,
      _,
      { shirt: 'XL', pants: 'L33 W33', pantsLoose: 'L33 W34' },
      { shirt: 'XL', pants: 'L33 W33', pantsLoose: 'L33 W34' },
      { shirt: '2XL', pants: 'L33 W36' },
      { shirt: '3XL', pants: 'L33 W38' },
      _
    ],

    // >215
    [_, _, _, _, _, _, _, _, _, _]
  ];

  const TOP_TEXT_MATRIX = [
    [_, _, _, _, _, _, _, _, _, _],
    [
      _,
      'Iz našeg dosadašnjeg iskustva sa kupcima, okvirna preporuka za vas je sigurno najmanja, S veličina, za gornje delove.',
      'Iz našeg dosadašnjeg iskustva sa kupcima, okvirna preporuka za vas je sigurno najmanja, S veličina, za gornje delove.',
      'Iz našeg dosadašnjeg iskustva sa kupcima, okvirna preporuka za vas je sigurno najmanja, S veličina, za gornje delove.',
      'Iz našeg dosadašnjeg iskustva sa kupcima, okvirna preporuka za vas je sigurno najmanja, S veličina, za gornje delove.',
      _, _, _, _, _
    ],
    [
      _,
      'Iz našeg dosadašnjeg iskustva sa kupcima, okvirna preporuka za vas je sigurno najmanja, S veličina, za gornje delove.',
      'Iz našeg dosadašnjeg iskustva sa kupcima, okvirna preporuka za vas je sigurno najmanja, S veličina, za gornje delove.',
      'Iz našeg dosadašnjeg iskustva sa kupcima, okvirna preporuka za vas je S veličina, za gornje delove.',
      'Iz našeg dosadašnjeg iskustva sa kupcima, okvirna preporuka za vas je S veličina, za gornje delove, ako želite da vam je taman, a M ako želite da vam je ležernije.',
      'Iz našeg dosadašnjeg iskustva sa kupcima, okvirna preporuka za vas je M veličina.',
      'Iz našeg dosadašnjeg iskustva sa kupcima, okvirna preporuka za vas je L veličina da vam bude knap, a XL da vam bude ležernije ali možda malo duže.',
      'Iz našeg dosadašnjeg iskustva sa kupcima, okvirna preporuka za vas je XL veličina da vam bude knap, a 2XL da vam bude ležernije. Moguće je da će vam gornji delovi biti malo duži.',
      _, _
    ],
    [
      _,
      'Iz našeg dosadašnjeg iskustva sa kupcima, okvirna preporuka za vas je sigurno najmanja, S veličina, za gornje delove.',
      'Iz našeg dosadašnjeg iskustva sa kupcima, okvirna preporuka za vas je S veličina da vam bude taman, a M da vam bude ležernije.',
      'Iz našeg dosadašnjeg iskustva sa kupcima, okvirna preporuka za vas je S veličina da vam bude knap, a M da vam bude ležernije.',
      'Iz našeg dosadašnjeg iskustva sa kupcima, okvirna preporuka za vas je M za gornje delove.',
      'Iz našeg dosadašnjeg iskustva sa kupcima, okvirna preporuka za vas je L za gornje delove.',
      'Iz našeg dosadašnjeg iskustva sa kupcima, okvirna preporuka za vas je XL za gornje delove, ali vam možda bude malo duže.',
      'Iz našeg dosadašnjeg iskustva sa kupcima, okvirna preporuka za vas je XL veličina da vam bude knap, a 2XL da vam bude ležernije, ali će vam biti malo duže.',
      _, _
    ],
    [
      _,
      'Iz našeg dosadašnjeg iskustva sa kupcima, okvirna preporuka za vas je sigurno najmanja, S veličina, za gornje delove, ali može da vam bude malo kraće.',
      'Iz našeg dosadašnjeg iskustva sa kupcima, okvirna preporuka za vas je S veličina, a M da vam bude malo ležernije.',
      'Iz našeg dosadašnjeg iskustva sa kupcima, okvirna preporuka za vas je S veličina da vam bude knap, a M da vam bude ležernije.',
      'Iz našeg dosadašnjeg iskustva sa kupcima, okvirna preporuka za vas je M veličina.',
      'Iz našeg dosadašnjeg iskustva sa kupcima, okvirna preporuka za vas je L veličina.',
      'Iz našeg dosadašnjeg iskustva sa kupcima, okvirna preporuka za vas je XL veličina.',
      'Iz našeg dosadašnjeg iskustva sa kupcima, okvirna preporuka za vas je 2XL veličina da vam bude knap, a 3XL da vam bude ležernije.',
      'Iz našeg dosadašnjeg iskustva sa kupcima, okvirna preporuka za vas je 3XL veličina.',
      _
    ],
    [
      _, _,
      'Iz našeg dosadašnjeg iskustva sa kupcima, okvirna preporuka za vas je M veličina za gornje delove.',
      'Iz našeg dosadašnjeg iskustva sa kupcima, okvirna preporuka za vas je M veličina za gornje delove.',
      'Iz našeg dosadašnjeg iskustva sa kupcima, okvirna preporuka za vas je L veličina za gornje delove.',
      'Iz našeg dosadašnjeg iskustva sa kupcima, okvirna preporuka za vas je L veličina za gornje delove.',
      'Iz našeg dosadašnjeg iskustva sa kupcima, okvirna preporuka za vas je XL veličina za gornje delove.',
      'Iz našeg dosadašnjeg iskustva sa kupcima, okvirna preporuka za vas je 2XL veličina za gornje delove.',
      'Iz našeg dosadašnjeg iskustva sa kupcima, okvirna preporuka za vas je 3XL veličina za gornje delove.',
      _
    ],
    [
      _, _,
      'Iz našeg dosadašnjeg iskustva sa kupcima, okvirna preporuka za vas je L veličina za gornje delove.',
      'Iz našeg dosadašnjeg iskustva sa kupcima, okvirna preporuka za vas je L veličina za gornje delove.',
      'Iz našeg dosadašnjeg iskustva sa kupcima, okvirna preporuka za vas je L veličina za gornje delove.',
      'Iz našeg dosadašnjeg iskustva sa kupcima, okvirna preporuka za vas je L veličina za gornje delove.',
      'Iz našeg dosadašnjeg iskustva sa kupcima, okvirna preporuka za vas je XL veličina za gornje delove.',
      'Iz našeg dosadašnjeg iskustva sa kupcima, okvirna preporuka za vas je 2XL veličina za gornje delove da vam bude taman, a 3XL da vam bude ležernije.',
      'Iz našeg dosadašnjeg iskustva sa kupcima, okvirna preporuka za vas je 3XL veličina za gornje delove.',
      _
    ],
    [
      _, _, _,
      'Iz našeg dosadašnjeg iskustva sa kupcima, okvirna preporuka za vas je L veličina za gornje delove, s tim što će vam biti malo kraće.',
      'Iz našeg dosadašnjeg iskustva sa kupcima, okvirna preporuka za vas je L veličina za gornje delove, s tim što će vam biti malo kraće.',
      'Iz našeg dosadašnjeg iskustva sa kupcima, okvirna preporuka za vas je L veličina za gornje delove, s tim što će vam biti malo kraće.',
      'Iz našeg dosadašnjeg iskustva sa kupcima, okvirna preporuka za vas je XL veličina za gornje delove ako želite da vam bude taman, a 2XL da vam bude ležernije.',
      'Iz našeg dosadašnjeg iskustva sa kupcima, okvirna preporuka za vas je 2XL veličina za gornje delove ako želite da vam bude taman, a 3XL da vam bude ležernije.',
      'Iz našeg dosadašnjeg iskustva sa kupcima, okvirna preporuka za vas je 3XL veličina za gornje delove.',
      _
    ],
    [
      _, _, _, _,
      'Iz našeg dosadašnjeg iskustva sa kupcima, okvirna preporuka za vas je XL veličina za gornje delove, s tim što će vam biti malo kraće.',
      'Iz našeg dosadašnjeg iskustva sa kupcima, okvirna preporuka za vas je XL veličina za gornje delove, s tim što će vam biti malo kraće.',
      'Iz našeg dosadašnjeg iskustva sa kupcima, okvirna preporuka za vas je 2XL veličina za gornje delove.',
      'Iz našeg dosadašnjeg iskustva sa kupcima, okvirna preporuka za vas je 2XL veličina za gornje delove, ako želite da vam bude taman, a 3XL ako želite da vam je ležernije.',
      'Iz našeg dosadašnjeg iskustva sa kupcima, okvirna preporuka za vas je 3XL veličina za gornje delove.',
      _
    ],
    [
      _, _, _, _, _,
      'Iz našeg dosadašnjeg iskustva sa kupcima, okvirna preporuka za vas je XL veličina za gornje delove, s tim što će vam biti malo kraće.',
      'Iz našeg dosadašnjeg iskustva sa kupcima, okvirna preporuka za vas je XL veličina za gornje delove, s tim što će vam biti malo kraće.',
      'Iz našeg dosadašnjeg iskustva sa kupcima, okvirna preporuka za vas je 2XL veličina za gornje delove.',
      'Iz našeg dosadašnjeg iskustva sa kupcima, okvirna preporuka za vas je 3XL veličina za gornje delove.',
      _
    ],
    [_, _, _, _, _, _, _, _, _, _]
  ];

  const FIT_LABEL = {
    uze: 'Uže',
    standardno: 'Standardno',
    sire: 'Šire / ležernije'
  };

  function bucketIndex(value, ranges) {
    const numericValue = parseFloat(value);

    if (Number.isNaN(numericValue)) return -1;

    for (let i = 0; i < ranges.length; i++) {
      if (numericValue >= ranges[i].min && numericValue <= ranges[i].max) {
        return i;
      }
    }

    return -1;
  }

  function onlyWSize(pants) {
    const match = pants && pants.match(/W(\d+)/);
    return match ? 'W' + match[1] : pants;
  }

  function pantsParts(pants) {
    const match = pants && pants.match(/L(\d+)\s*W(\d+)/);

    return match
      ? { length: match[1], width: match[2] }
      : null;
  }

  function lookup(height, weight) {
    const h = bucketIndex(height, HEIGHT_RANGES);
    const w = bucketIndex(weight, WEIGHT_RANGES);

    if (h === -1 || w === -1) return null;

    return MATRIX[h][w] || null;
  }

  function lookupTopText(height, weight) {
    const h = bucketIndex(height, HEIGHT_RANGES);
    const w = bucketIndex(weight, WEIGHT_RANGES);

    if (h === -1 || w === -1) return '';

    return TOP_TEXT_MATRIX[h][w] || '';
  }

  function buildRecommendations(base) {
    if (!base) return null;

    return {
      uze: {
        shirt: base.shirtTight || base.shirt,
        pants: base.pantsTight || base.pants
      },
      standardno: {
        shirt: base.shirt,
        pants: base.pants
      },
      sire: {
        shirt: base.shirtLoose || base.shirt,
        pants: base.pantsLoose || base.pants
      }
    };
  }

  /* ---------------------------------------------------------------
     DOM refs
  --------------------------------------------------------------- */
  const openers   = document.querySelectorAll('[data-size-guide-open]');
  const closers   = modal.querySelectorAll('[data-size-guide-close]');
  const form      = modal.querySelector('[data-size-guide-form]');
  const errorEl   = modal.querySelector('[data-size-guide-error]');
  const submitBtn = modal.querySelector('.size-guide__submit');
  const heightInp = modal.querySelector('#SizeGuideHeight');
  const weightInp = modal.querySelector('#SizeGuideWeight');

  const viewForm   = modal.querySelector('[data-view="form"]');
  const viewResult = modal.querySelector('[data-view="result"]');
  const editBtn    = modal.querySelector('[data-size-guide-edit]');

  const heightOut = modal.querySelector('[data-height-out]');
  const weightOut = modal.querySelector('[data-weight-out]');
  const fitLabel  = modal.querySelector('[data-fit-label]');

  const noExpBox     = modal.querySelector('[data-no-experience]');
  const topsSection  = modal.querySelector('[data-section-tops]');
  const topsPrimary  = modal.querySelector('[data-tops-primary]');
  const topsAlts     = modal.querySelector('[data-tops-alts]');
  const pantsSection = modal.querySelector('[data-section-pants]');
  const pantsPrimary = modal.querySelector('[data-pants-primary]');

  /* ---------------------------------------------------------------
     localStorage persistence
  --------------------------------------------------------------- */
  const STORAGE_KEY = 'lazareSizeGuide';

  function loadSaved() {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return null;

      const data = JSON.parse(raw);
      if (!data || typeof data !== 'object') return null;
      if (!data.height || !data.weight) return null;

      return data;
    } catch (e) {
      return null;
    }
  }

  function save(height, weight, fit) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify({ height, weight, fit }));
    } catch (e) {
      // quota / privacy mode — ignore
    }
  }

  function prefillForm(saved) {
    if (!saved) return;

    if (heightInp) heightInp.value = saved.height;
    if (weightInp) weightInp.value = saved.weight;

    const fitRadio = modal.querySelector('input[name="fit"][value="' + (saved.fit || 'standardno') + '"]');

    if (fitRadio) fitRadio.checked = true;

    updateReadyState();
  }

  /* ---------------------------------------------------------------
     Inline open / close
  --------------------------------------------------------------- */
  let activeOpener = null;

  function openInline(opener) {
    activeOpener = opener;

    opener.insertAdjacentElement('afterend', modal);

    modal.hidden = false;
    modal.classList.add('is-open', 'size-guide--inline');
    opener.setAttribute('aria-expanded', 'true');

    const saved = loadSaved();

    if (saved) {
      prefillForm(saved);
      renderResult(parseFloat(saved.height), parseFloat(saved.weight), saved.fit || 'standardno');
      showView('result');
    } else {
      showView('form');
    }
  }

  function closeInline() {
    modal.classList.remove('is-open');
    modal.hidden = true;

    if (activeOpener) {
      activeOpener.setAttribute('aria-expanded', 'false');
    }
  }

  function toggleInline(opener) {
    const isOpen = !modal.hidden && modal.classList.contains('is-open');

    if (isOpen && activeOpener === opener) {
      closeInline();
    } else {
      openInline(opener);
    }
  }

  openers.forEach((btn) => {
    btn.addEventListener('click', function () {
      toggleInline(btn);
    });
  });

  closers.forEach((btn) => {
    btn.addEventListener('click', closeInline);
  });

  /* ---------------------------------------------------------------
     Submit button ready state
  --------------------------------------------------------------- */
  function updateReadyState() {
    if (!submitBtn) return;

    const ready =
      heightInp &&
      weightInp &&
      heightInp.value.trim() !== '' &&
      weightInp.value.trim() !== '';

    submitBtn.classList.toggle('is-ready', !!ready);
  }

  [heightInp, weightInp].forEach((el) => {
    if (el) el.addEventListener('input', updateReadyState);
  });

  /* ---------------------------------------------------------------
     View switching
  --------------------------------------------------------------- */
  function showView(name) {
    if (name === 'result') {
      viewForm.hidden = true;
      viewResult.hidden = false;
    } else {
      viewForm.hidden = false;
      viewResult.hidden = true;
    }
  }

  if (editBtn) {
    editBtn.addEventListener('click', function () {
      showView('form');
    });
  }

  /* ---------------------------------------------------------------
     Prose builders
  --------------------------------------------------------------- */
  function emphasizeSizes(text) {
    return text.replace(/\b(3XL|2XL|XL|L|M|S)\b/g, '<strong>$1</strong>');
  }

  function pantsProse(taman, lezernije, fit) {
    const tail =
      ', ovo je naša okvirna preporuka. Do sad se pokazalo da je u 95% slučajeva ' +
      'ispravna, ali uvek postoji minimalnih 5% šanse da vam neće odgovarati, ' +
      'sve zavisno od načina kako volite da nosite.';
    const fitText = fit === 'knap' ? 'knap' : 'taman';

    if (!lezernije || taman === lezernije) {
      return 'Za donje delove preporuka je veličina <strong>' + taman + '</strong>' + tail;
    }

    const tamanParts = pantsParts(taman);
    const lezernijeParts = pantsParts(lezernije);

    if (tamanParts && lezernijeParts) {
      const lengthDiffers = tamanParts.length !== lezernijeParts.length;
      const widthDiffers = tamanParts.width !== lezernijeParts.width;

      if (lengthDiffers && !widthDiffers) {
        return 'Za donje delove preporuka je veličina <strong>' + taman + '</strong> ' +
          'da vam bude taman do zgloba dugačko, a <strong>' + lezernije + '</strong> ' +
          'da vam bude malo duže kod zgloba' + tail;
      }

      if (lengthDiffers && widthDiffers) {
        return 'Za donje delove preporuka je dužina <strong>L' + tamanParts.length + '</strong> ' +
          'da vam bude taman do zgloba dugačko, a <strong>L' + lezernijeParts.length + '</strong> ' +
          'da vam bude malo duže kod zgloba. Što se tiče širine odnosno W, ' +
          '<strong>W' + tamanParts.width + '</strong> bi vam bilo ' + fitText +
          ', a <strong>W' + lezernijeParts.width + '</strong> bi vam bilo malo ležernije' + tail;
      }
    }

    return 'Za donje delove preporuka je veličina <strong>' + taman + '</strong> ' +
      'da vam bude ' + fitText + ', a <strong>' + lezernije + '</strong> da vam bude ležernije' + tail;
  }

  /* ---------------------------------------------------------------
     Render result — scoped to product kind
  --------------------------------------------------------------- */
  const productKind = ['bottoms', 'bermude'].includes(modal.dataset.productKind)
    ? modal.dataset.productKind
    : 'tops';

  function renderResult(height, weight, fit) {
    const fitName = FIT_LABEL[fit] || 'Standardno';

    heightOut.textContent = height;
    weightOut.textContent = weight;
    fitLabel.textContent = fitName;

    const base = lookup(height, weight);
    const recs = buildRecommendations(base);

    if (!recs) {
      noExpBox.hidden = false;
      topsSection.hidden = true;
      pantsSection.hidden = true;
      return;
    }

    noExpBox.hidden = true;

    if (productKind === 'bottoms' || productKind === 'bermude') {
      topsSection.hidden = true;

      let tamanPants = base.pants;
      let lezernijePants = base.pantsLoose || base.pants;

      if (productKind === 'bermude') {
        tamanPants = onlyWSize(tamanPants);
        lezernijePants = onlyWSize(lezernijePants);
      }

      const sameLezernije = tamanPants === lezernijePants;

      pantsSection.hidden = false;
      pantsPrimary.innerHTML = pantsProse(tamanPants, sameLezernije ? null : lezernijePants, base.pantsFit);
    } else {
      pantsSection.hidden = true;

      const topText = lookupTopText(height, weight);

      topsSection.hidden = false;
      topsPrimary.innerHTML = emphasizeSizes(topText);
      topsAlts.innerHTML = '';
    }
  }

  /* ---------------------------------------------------------------
     Form submit
  --------------------------------------------------------------- */
  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();

      const data = new FormData(form);
      const height = parseFloat(data.get('height'));
      const weight = parseFloat(data.get('weight'));
      const fit = data.get('fit') || 'standardno';

      if (!height || !weight) {
        if (errorEl) {
          errorEl.hidden = false;
          errorEl.textContent = 'Molimo unesite visinu i težinu.';
        }
        return;
      }

      if (errorEl) errorEl.hidden = true;

      save(height, weight, fit);
      renderResult(height, weight, fit);
      showView('result');
    });
  }
})();
